/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_Generate_BriefInputs */

const en_interview_prepare_generate_brief = /** @type {(inputs: Interview_Prepare_Generate_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Brief`)
};

const de_interview_prepare_generate_brief = /** @type {(inputs: Interview_Prepare_Generate_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht generieren`)
};

const fr_interview_prepare_generate_brief = /** @type {(inputs: Interview_Prepare_Generate_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer la fiche`)
};

const es_interview_prepare_generate_brief = /** @type {(inputs: Interview_Prepare_Generate_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar informe`)
};

const it_interview_prepare_generate_brief = /** @type {(inputs: Interview_Prepare_Generate_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera scheda`)
};

const nl_interview_prepare_generate_brief = /** @type {(inputs: Interview_Prepare_Generate_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer notitie`)
};

const pl_interview_prepare_generate_brief = /** @type {(inputs: Interview_Prepare_Generate_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj notatkę`)
};

const fi_interview_prepare_generate_brief = /** @type {(inputs: Interview_Prepare_Generate_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo tiivistelmä`)
};

const da_interview_prepare_generate_brief = /** @type {(inputs: Interview_Prepare_Generate_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer oversigt`)
};

const sv_interview_prepare_generate_brief = /** @type {(inputs: Interview_Prepare_Generate_BriefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera översikt`)
};

/**
* | output |
* | --- |
* | "Generate Brief" |
*
* @param {Interview_Prepare_Generate_BriefInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_generate_brief = /** @type {((inputs?: Interview_Prepare_Generate_BriefInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Generate_BriefInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_generate_brief(inputs)
	if (locale === "fr") return fr_interview_prepare_generate_brief(inputs)
	if (locale === "es") return es_interview_prepare_generate_brief(inputs)
	if (locale === "it") return it_interview_prepare_generate_brief(inputs)
	if (locale === "nl") return nl_interview_prepare_generate_brief(inputs)
	if (locale === "pl") return pl_interview_prepare_generate_brief(inputs)
	if (locale === "fi") return fi_interview_prepare_generate_brief(inputs)
	if (locale === "da") return da_interview_prepare_generate_brief(inputs)
	if (locale === "sv") return sv_interview_prepare_generate_brief(inputs)
	return en_interview_prepare_generate_brief(inputs)
});